import * as Sentry from '@sentry/react';
import { Helmet } from 'react-helmet-async';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { Button } from '@/shared/ui/button';

export function ErrorPage() {
  const error = useRouteError();

  // Sentry에 에러 리포트
  if (error instanceof Error) {
    Sentry.captureException(error);
  }

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <>
          <Helmet>
            <title>404 - 페이지를 찾을 수 없습니다 | 동구바이오제약</title>
          </Helmet>
          <div className="flex h-screen flex-col items-center justify-center gap-4">
            <h1 className="text-4xl font-bold">404</h1>
            <p className="text-muted-foreground">페이지를 찾을 수 없습니다.</p>
            <Button asChild>
              <Link to="/">홈으로 돌아가기</Link>
            </Button>
          </div>
        </>
      );
    }
  }

  return (
    <>
      <Helmet>
        <title>오류 발생 | 동구바이오제약</title>
      </Helmet>
      <div className="flex h-screen flex-col items-center justify-center gap-4">
        <h1 className="text-4xl font-bold">오류 발생</h1>
        <p className="text-muted-foreground">예상치 못한 오류가 발생했습니다.</p>
        <Button onClick={() => window.location.reload()}>페이지 새로고침</Button>
      </div>
    </>
  );
}
